import { DB } from '@/extensions/db'
import { newGuid } from '../utils'

let instance = null

export class Device {
  constructor () {
    instance = instance || this

    this._table = DB.device

    return instance
  }

  /**
   * @param [string] options.type
   *
   * @returns [number] device id
   */
  async add (options) {
    return this._table.add({
      id: newGuid(),
      type: options.type
    })
  }

  async delete (id) {
    return this._table.delete(id)
  }

  async all () {
    return this._table.toArray()
  }
}



// WEBPACK FOOTER //
// ./src/models/device.js